import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Курси',
    href: '#courses'
  }, {
    name: 'Роботи',
    href: '#gallery'
  }, {
    name: 'Про мене',
    href: '#about'
  }, {
    name: 'Контакти',
    href: '#footer'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md py-4 border-b border-line shadow-sm' : 'bg-transparent py-6'}`} data-id="element-169">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-170">
        <div className="flex flex-col" data-id="element-171">
          <span className="font-heading text-2xl font-bold tracking-tight text-ink" data-id="element-172">
            Валентина
          </span>
          <span className="text-[10px] uppercase tracking-widest text-muted mt-0.5" data-id="element-173">
            майстер-перукар
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-174">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-muted hover:text-ink transition-colors" data-id="element-175">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-176">
          <a href="#contact" className="px-6 py-2.5 bg-ink text-white text-xs font-medium tracking-wide uppercase rounded-full hover:bg-black transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-177">
            Записатися
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-ink" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-178">
          {isMobileMenuOpen ? <X size={24} data-id="element-179" /> : <Menu size={24} data-id="element-180" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-line shadow-xl py-6 px-6 flex flex-col space-y-6" data-id="element-181">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-muted hover:text-ink transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-182">
              {link.name}
            </a>)}
          <a href="#contact" className="inline-block text-center px-6 py-4 bg-ink text-white text-sm font-medium tracking-wide uppercase rounded-full hover:bg-black transition-colors mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-183">
            Записатися
          </a>
        </div>}
    </header>;
}